import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import {
  FooterSection,
  Title,
  Para,
  Large,
  ExternalLarge,
  Chat
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {

  return (
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={6} md={6} sm={12} xs={24}>
              <Title>{t("Contact")}</Title>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="mailto:nearalize@gmail.com">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={6} md={6} sm={12} xs={24}>
              <Title>{t("Policy")}</Title>
              <ExternalLarge href="/privacy-policy.html">Privacy Policy</ExternalLarge>
              <Large to="/child-safety">Child Safety</Large>
              <Large to="/">{t("Application Security")}</Large>
              <Large to="/">{t("Software Principles")}</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={24}>
              <Title>{t("Address")}</Title>
              <Para>Rancho Santa Margarita</Para>
              <Para>2131 Elk Street</Para>
              <Para>California</Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
  );
};

export default withTranslation()(Footer);
